import { Deserializable } from 'rome-library';

export class UserContext implements Deserializable {
  AcceptsPrivacyNotes: boolean;
  AccessTokenGuid: string;
  AccessToken: string;
  AllowProcessExistingBusiness: boolean;
  ClientId: string;
  DisplayFeatureWindow: boolean;
  ExpiresIn: number;
  IsAipCertificateAvailable: boolean;
  IsDocumentUploadAllowed: boolean;
  IsFirmStartingInTheFuture: boolean;
  ProfileComplete: boolean;
  TokenType: boolean;

  public deserialize(data: any): this {
    this.AcceptsPrivacyNotes = data.acceptsPrivacyNotes === 'True';
    this.AccessTokenGuid = data.accessTokenGuid;
    this.AccessToken = data.access_token;
    this.AllowProcessExistingBusiness = data.allowProcessExistingBusiness === 'True';
    this.ClientId = data.client_id;
    this.DisplayFeatureWindow = data.displayFeatureWindow === 'True';
    this.ExpiresIn = data.expires_in;
    this.IsAipCertificateAvailable = data.isAipCertificateAvailable === 'True';
    this.IsDocumentUploadAllowed = data.isDocumentUploadAllowed === 'True';
    this.IsFirmStartingInTheFuture = data.isFirmStartingInTheFuture === 'True';
    this.ProfileComplete = data.profileComplete === 'True';
    this.TokenType = data.token_type;

    return this;
  }
}
